function getFeatureId(feature, promoteId) {
    return promoteId ? feature.properties[promoteId] : feature.id;
}
export function isUpdateableGeoJSON(data, promoteId) {
    // null can be updated
    if (data == null) {
        return true;
    }
    // a single feature with an id can be updated, need to explicitly check against null because 0 is a valid feature id that is falsy
    if (data.type === 'Feature') {
        return getFeatureId(data, promoteId) != null;
    }
    // a feature collection can be updated if every feature has an id, and the ids are all unique
    // this prevents us from silently dropping features if ids get reused
    if (data.type === 'FeatureCollection') {
        const seenIds = new Set();
        for (const feature of data.features) {
            const id = getFeatureId(feature, promoteId);
            if (id == null) {
                return false;
            }
            if (seenIds.has(id)) {
                return false;
            }
            seenIds.add(id);
        }
        return true;
    }
    return false;
}
export function toUpdateable(data, promoteId) {
    const result = new Map();
    if (data == null) {
        // empty result
    }
    else if (data.type === 'Feature') {
        result.set(getFeatureId(data, promoteId), data);
    }
    else {
        for (const feature of data.features) {
            result.set(getFeatureId(feature, promoteId), feature);
        }
    }
    return result;
}
// mutates updateable
export function applySourceDiff(updateable, diff, promoteId) {
    var _a, _b, _c, _d;
    if (diff.removeAll) {
        updateable.clear();
    }
    if (diff.remove) {
        for (const id of diff.remove) {
            updateable.delete(id);
        }
    }
    if (diff.add) {
        for (const feature of diff.add) {
            const id = getFeatureId(feature, promoteId);
            if (id != null) {
                updateable.set(id, feature);
            }
        }
    }
    if (diff.update) {
        for (const update of diff.update) {
            let feature = updateable.get(update.id);
            if (feature == null) {
                continue;
            }
            // be careful to clone the feature and/or properties objects to avoid mutating our input
            const cloneFeature = update.newGeometry || update.removeAllProperties;
            // note: removeAllProperties gives us a new properties object, so we can skip the clone step
            const cloneProperties = !update.removeAllProperties && (((_a = update.removeProperties) === null || _a === void 0 ? void 0 : _a.length) > 0 || ((_b = update.addOrUpdateProperties) === null || _b === void 0 ? void 0 : _b.length) > 0);
            if (cloneFeature || cloneProperties) {
                feature = { ...feature };
                updateable.set(update.id, feature);
                if (cloneProperties) {
                    feature.properties = { ...feature.properties };
                }
            }
            if (update.newGeometry) {
                feature.geometry = update.newGeometry;
            }
            if (update.removeAllProperties) {
                feature.properties = {};
            }
            else if (((_c = update.removeProperties) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                for (const prop of update.removeProperties) {
                    if (Object.prototype.hasOwnProperty.call(feature.properties, prop)) {
                        delete feature.properties[prop];
                    }
                }
            }
            if (((_d = update.addOrUpdateProperties) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                for (const { key, value } of update.addOrUpdateProperties) {
                    feature.properties[key] = value;
                }
            }
        }
    }
}
//# sourceMappingURL=geojson_source_diff.js.map